import { Node } from 'tiptap';

export default class GridCards extends Node {
	get name() {
		return 'grid_cards';
	}

	get schema() {
		return {
			content: 'grid_card+',
			group: 'block',
			marks: 'link',
			toDOM: () => {
				return [
					'section',
					{
						class: 'gr-cols-3 gr-responsive',
					},
					0
				]
			},
			parseDOM: [
				{
					tag: 'section.gr-cols-3',
					getAttrs: dom => ({
						columns: dom.getAttribute('grid-cols')
					})
				}
			],
		}
	}
}